<template>
    <div>
        <div class="row" v-if="loading && !workshops.length">
            <Loader style="width: 100%;" />
        </div>
        <div v-if="workshops.length === 0">
            No workshop requests were found.
        </div>
        <div v-else>
            <div class="session" v-for="(workshop, index) in workshops" :key="workshop.id">
                <div class="row">
                    <div class="col-12 col-lg-8">
                        <h3>{{ workshop.topic }}</h3>
                        <h5 v-if="workshop.host">{{ workshop.host.name }}</h5>
                        <p>
                            <b>Requested At:</b> 
                            {{ workshop.requested_time | format('MM/DD/YYYY h:mmA') }}
                        </p>
                        <p>
                            <b>Starting At:</b> 
                            {{ workshop.start_time | format('MM/DD/YYYY h:mmA') }}
                        </p>
                        <span class="spot-number d-lg-none">
                            <span>User Limit: {{workshop.maxNumberOfAttendees}}</span>
                        </span>
                    </div>
                    <div class="col-12 d-none d-lg-block col-lg-4 text-right">
                        <ul class="pills">
                            <li>User Limit: {{ workshop.maxNumberOfAttendees }}</li>
                        </ul>
                    </div>
                </div>
                <div class="row" v-if="workshop.struggle_areas.length">
                    <ul class="pills">
                        <li v-for="area of workshop.struggle_areas" :key="area.id">
                            {{area.name}}
                        </li>
                    </ul>
                </div>
                    <div class="row mb-2" v-show="workshop.document_url">
                        <div class="col-12 col-lg-4">
                            <a :href="workshop.document_url" target="_blank">
                            <button type="button"  class="btn btn-secondary btn-block w-100 border">
                                <span>Documents            </span>
                                <font-awesome-icon
                                    :icon="['fas', 'file-alt']"
                                    title="View Document"
                                    class="icon alt fa-fw"
                                />
                            </button>
                            </a>
                        </div>
                    </div>
                    <div class="accordion" role="tablist">
                        <b-card no-body class="mb-1">
                            <b-card-header header-tag="header" class="p-1" role="tab">
                                <button class="btn btn-secondary block w-100" v-b-toggle="'collapse-description-'+ index">
                                View Description
                            </button>
                            </b-card-header>
                            <b-collapse :id="'collapse-description-'+ index" accordion="my-accordion" role="tabpanel">
                                <b-card-body class="description">
                                    <b-card-text>{{ workshop.description}}</b-card-text>
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                    </div>
                            <div class="row mt-2">
                                <div class="col-12 col-md-6 offset-md-6 text-right d-flex justify-content-between">
                                <button type="button" 
                                        @click="rejectWorkshop(workshop.id)" 
                                        class="btn btn-secondary border mr-1 w-100">
                                    <font-awesome-icon v-if="savingReject" :spin="true" :icon="['fas', 'spinner']" class="icon alt" />
                                    <span v-else>Reject</span>
                                </button>
                                <button type="button" @click="approveWorkshop(workshop.id)" class="btn btn-primary w-100">
                                    <font-awesome-icon v-if="savingApprove" :spin="true" :icon="['fas', 'spinner']" class="icon alt" />
                                    <span v-else>Approve</span>
                                </button>
                            </div>
                        </div>
                </div>
            <div>
                <Loader v-if="loading" style="width: 100%" />
                <button class='btn' v-else-if="pageToken" @click="loadWorkshops">
                    Load Next
                </button>
                <div v-else>
                    <p>
                        <font-awesome-icon :icon="['fas', 'check-circle']" class="icon alt" />
                        All Results Loaded
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import WorkshopClient from '@/api/WorkshopClient';
import Loader from '@/components/Loader';
import WorkshopView from '../WorkshopView';

export default {
    name: 'WorkshopsRequestList',
    components : {
        Loader,
    },
    props: {
        filters: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            workshopClient: new WorkshopClient(this.$http),
            workshops: [],
            pageToken: null,
            loading: false,
            savingReject:false,
            savingApprove:false,
            excludedStatuses: ['approved', 'rejected','canceled' ],
        }
    },
    async mounted() {
        this.loadWorkshops();
    },
    methods: {
    async loadWorkshops() {
        try {
            this.loading = true;
            if (this.pageToken == null) {
                this.workshops.length = 0;
            }

            const response = await this.workshopClient.listForAdmin(
                this.pageToken,
                this.filters.counselor_id,
                this.filters.start_time_after,
                this.filters.start_time_before,
                this.filters.related_topics,
                this.excludedStatuses);

            for(const workshop of (response.workshops || []).map(this.toCounselorGroupSessionModel)){
                this.workshops.push(workshop);
            }

            this.pageToken = response.nextPageToken;
            
        } catch (ex) {
            console.error(ex)
        } finally {
            this.loading = false;
        }
    },
    toCounselorGroupSessionModel(val, index, arr){
        return new WorkshopView(val);
    },
    async approveWorkshop(id) {
        this.savingAccept = true;
        try {
            await this.workshopClient.approveWorkshopRequest(id);
            this.$emit('approved', id);
            this.notify("Workshop has been approved!", false)
        } catch (error) {
            this.notify("There was an error. Please try again", true)
        } finally {
            this.savingApprove = false;
        }
        

    },
    async rejectWorkshop(id) {
        this.savingReject = true;
        try {
            await this.workshopClient.rejectWorkshopRequest(id);
            this.$emit('rejected', id);
            this.notify("Workshop has been rejected!", false)
        } catch (error) {
            this.notify("There was an error. Please try again", true)
        } finally {
            this.savingReject = false;
        }
    },
    notify(msg, error)
    {
        this.$store.commit('setGlobalAlert', {
                msg: msg,
                error: error
            });
    },
    freshLoadWorkshops(){
            this.pageToken = null;
            return this.loadWorkshops();
        }
}
}
</script>

<style lang="scss" scoped>
    .session {
      @include border-radius($border-radius);

      border: solid 1px rgba(white, 0.5);
      padding: 30px;
      margin-bottom: 10px;
      background-color: $off-blue;

      p {
        color: rgba(white, 0.75);
        font-size: 18px;
        margin-bottom: 20px;
      }

      .spot-number {
        color: $green;
        margin-bottom: 30px;
        display: block;
        font-weight: bold;
      }
    }

    .description {
        background-color: $textbox-bg-color;
        min-height: 100px;
        overflow: auto;
        word-wrap: break-word;

    }
    .accordion {
        .card {
            background-color: $off-blue;
            border: 0px;
        }
        .btn {
            background-color: $dark-green;
            border-color: $border-color;
        }
    }

</style>